import React, { useContext, useEffect, useState } from "react";
import MainPanelHeader from "../../layouts/mainPanelHeader";
import { Button } from "react-bootstrap";
import MessagesModal from "./MessagesModal";
import PaginationComponent from "../../component/global/PaginationComponent";
import { ReactComponent as SearchIcon } from "../../asset/icons/searchIcon.svg";
import { ReactComponent as CalenderIcon } from "../../asset/icons/calenderIconGray.svg";
import DatePickerModal from "../../component/global/DatePicker";
import { ReactComponent as DidebanLogo } from "../../asset/icons/dideban_logo_blue.svg";

import MessagesAiSummary from "./MessagesAiSummary";
import { getFeedbacks } from "../../controlers/messages/FeedbackController";
import { ToastContext } from "../../component/global/ToastContext";

import "./style.scss";
import FeedbackItem from "./FeedbackItem";
import FeedbackItemList from "./FeedbackItemList";
import { get } from "../../controlers/global/ConfigRequest";
import {
    COMPANY_LIST_URL,
    FEEDBACK_EXCEL,
    GET_FEEDBACK_COUNTS,
    GET_MONITORING_FEEDBACK_LIST,
    GET_RECEIVED_FEEDBACK_LIST,
    GET_SEND_FEEDBACK_LIST,
    REPORT_GET_ITEM_TYPE_TREE,
    USER_GET_FEEDBACK_COUNTS,
} from "../../helperData/ApiAddress";
import SearchSelectBox from "../../component/global/SearchSelectBox";
import { GlobalStateContext } from "../../layouts/GlobalStates";
import axios from "axios";
import TreeSearchSelect from "../../component/global/TreeSearchSelect";
import MessageStatusFilter from "./MessageStatusFilter";
import { MESSAGE_STATUS_FILTER } from "./messageStatus";

import { ReactComponent as GridViewIcon } from "./../../asset/icons/gridViewIcon.svg";
import { ReactComponent as ListViewIcon } from "./../../asset/icons/listViewIcons.svg";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import excelIcon from "../../asset/icons/excelIcon.svg";
import { MessageContext } from "./MessageContext";

export { MessageContext };

let checkUpdate;

export default function Messages() {
    const { userType } = useParams();
    const [startDate, setStartDate] = useState({
        fa: "",
        en: "",
    });
    const [endDate, setEndDate] = useState({
        fa: "",
        en: "",
    });
    const [filterType, setFilterType] = useState("item");
    const [startDatePicker, setStartDatePicker] = useState(false);
    const [endDatePicker, setEndDatePicker] = useState(false);
    const [viewType, setViewType] = useState("list");
    const [messageModal, setMessageModal] = useState(false);
    const [feedbackId, setFeedbackId] = useState(undefined);
    const [feedbacks, setFeedbacks] = useState([]);
    const [empty, setEmpty] = useState();
    const [total, setTotal] = useState(0);
    const [loader, setLoader] = useState(true);
    const [ajaxing, setAjaxing] = useState(false);
    const [pages, setPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [sendCurrentPage, setSendCurrentPage] = useState(0);
    const [recievedCurrentPage, setRecievedCurrentPage] = useState(0);
    const [monitoringCurrentPage, setMonitoringCurrentPage] = useState(0);
    const [mobileTool, setMobileTool] = useState(null);
    const [searchType, setSearchType] = useState("item_name");
    const [searchStr, setSearchStr] = useState("");
    const [statusFilter, setStatusFilter] = useState(MESSAGE_STATUS_FILTER.ALL);
    const [gridView, setGridView] = useState(false);
    const [itemTypeTree, setItemTypeTree] = useState({
        name: "",
        id: 0,
        toggled: true,
        className: "zeroLevel",
        children: [],
    });
    const [currentCompany, setCurrentCompany] = useState([]);
    const [feedbackCounts, setFeedbackCounts] = useState();
    const [loading, setLoading] = useState(false);
    const [activeShowFeedbacks, setActiveShowFeedbacks] = useState("all");
    const [searchResultsCount, setSearchResultsCount] = useState(0);
    const [newFeedbacksCount, setNewFeedbacksCount] = useState();
    const show = useContext(ToastContext);
    const { setRefreshNewCount } = useContext(GlobalStateContext);
    const [searchedItem, setSearchedItem] = useState();
    const [refreshMode, setRefreshMode] = useState(false);
    const [currentCompanyForAdminUser, setCurrentCompanyForAdminUser] =
        useState();
    const [compantList, setCompanyList] = useState([]);
    const { t } = useTranslation();

    useEffect(() => {
        if (window.sessionStorage.usertype == 1) {
            get(COMPANY_LIST_URL, {}).then((r) => {
                setCompanyList(r.results);
                setCurrentCompany(
                    r.results.map((e) => {
                        return { name: e.name, value: e.id };
                    })[0].value
                );
            });
        } else {
            setCurrentCompany(window.sessionStorage.usercompany);
        }
    }, []);

    const showModal = (id) => {
        setMessageModal(true);
        setFeedbackId(id);
    };

    const buildListParams = (pageIndex, status = statusFilter) => {
        const params = {
            page: pageIndex + 1,
            [searchType]: searchStr,
            datetime_from: startDate.en,
            datetime_to: endDate.en,
            company: currentCompanyForAdminUser,
        };
        if (status) {
            params.feedback_status = status;
        }
        return params;
    };

    const fetchData = ({ pageIndex }, loader = true, status = statusFilter) => {
        setEmpty(false);

        if (loader) {
            setLoading(true);
        }

        setActiveShowFeedbacks("all");

        getFeedbacks(
            buildListParams(pageIndex, status),
            userType
        )
            .then((data) => {
                setAjaxing(true);
                setFeedbacks(data.results || []);

                setLoading(false);

                if (!data.results || data.results.length === 0) {
                    setEmpty(true);
                } else {
                    setEmpty(false);
                }

                setTotal(data.count || 0);
                setPages(Math.ceil((data.count || 0) / 20));
                if (searchStr !== "") {
                    setSearchResultsCount(data.count);
                }
            })
            .catch(() => {
                setFeedbacks([]);
                setEmpty(true);
                setLoading(false);
            })
            .finally((_) => {
                setLoader(false);
                setAjaxing(false);
            });
    };

    const getSendFeddbackList = ({ pageIndex }, loader = true, status = statusFilter) => {
        if (loader) {
            setLoading(true);
        }
        setActiveShowFeedbacks("send");
        get(GET_SEND_FEEDBACK_LIST, buildListParams(pageIndex, status))
            .then((data) => {
                setAjaxing(true);
                setFeedbacks(data.results);

                if (data.results.length === 0) {
                    setEmpty(true);
                } else {
                    setEmpty(false);
                }
                setTotal(data.count);
                setPages(Math.ceil(data.count / 20));
                setLoading(false);
                if (searchStr !== "") {
                    setSearchResultsCount(data.count);
                }
            })
            .finally((_) => {
                setLoader(false);
                setAjaxing(false);
                setLoading(false);
            });
    };

    const getMonitoringFeedbackList = ({ pageIndex }, loader = true, status = statusFilter) => {
        setActiveShowFeedbacks("monitoring");
        if (loader) {
            setLoading(true);
        }
        get(GET_MONITORING_FEEDBACK_LIST, buildListParams(pageIndex, status))
            .then((data) => {
                setAjaxing(true);
                setFeedbacks(data.results);
                if (data.results.length === 0) {
                    setEmpty(true);
                } else {
                    setEmpty(false);
                }
                setTotal(data.count);
                setPages(Math.ceil(data.count / 20));
                setLoading(false);
                if (searchStr !== "") {
                    setSearchResultsCount(data.count);
                }
            })
            .finally((_) => {
                setLoader(false);
                setAjaxing(false);
                setLoading(false);
            });
    };

    const getReceivedFeedbackList = ({ pageIndex }, loader = true, status = statusFilter) => {
        if (loader) {
            setLoading(true);
        }
        setActiveShowFeedbacks("received");
        get(GET_RECEIVED_FEEDBACK_LIST, buildListParams(pageIndex, status))
            .then((data) => {
                setAjaxing(true);
                setFeedbacks(data.results);
                setLoading(false);
                if (data.results.length === 0) {
                    setEmpty(true);
                } else {
                    setEmpty(false);
                }
                setTotal(data.count);
                setPages(Math.ceil(data.count / 20));
                if (searchStr !== "") {
                    setSearchResultsCount(data.count);
                }
            })
            .finally((_) => {
                setLoader(false);
                setAjaxing(false);
                setLoading(false);
            });
    };

    const handleBookmarkChange = (id, bookmark) => {
        const index = feedbacks.findIndex((feedback) => feedback.id === id);
        setFeedbacks([]);
        setFeedbacks([
            ...feedbacks.slice(0, index),
            { ...feedbacks[index], bookmark },
            ...feedbacks.slice(index + 1),
        ]);
    };

    const [itemTypeTreeSelected, setItemTypeTreeSelected] = useState();

    const itemTypeSelectHandle = (e, a, item) => {
        setItemTypeTreeSelected(item);
        setSearchStr(item.id);
    };

    const getFeedbackCounts = () => {
        const API =
            userType === "organ"
                ? GET_FEEDBACK_COUNTS
                : USER_GET_FEEDBACK_COUNTS;
        get(API)
            .then((r) => {
                setFeedbackCounts(r);
            })
            .catch(() => {});
    };

    const handleCurrentPage = (e) => {
        if (activeShowFeedbacks === "send") {
            setSendCurrentPage(e);
        } else if (activeShowFeedbacks === "received") {
            setRecievedCurrentPage(e);
        } else if (activeShowFeedbacks === "monitoring") {
            setMonitoringCurrentPage(e);
        } else {
            setCurrentPage(e);
        }
    };

    const handleSearchFunc = (status = statusFilter) => {
        const nextStatus = typeof status === "string" ? status : statusFilter;
        if (activeShowFeedbacks === "send") {
            getSendFeddbackList({ pageIndex: 0 }, true, nextStatus);
        } else if (activeShowFeedbacks === "monitoring") {
            getMonitoringFeedbackList({ pageIndex: 0 }, true, nextStatus);
        } else if (activeShowFeedbacks === "received") {
            getReceivedFeedbackList({ pageIndex: 0 }, true, nextStatus);
        } else {
            fetchData({ pageIndex: 0 }, true, nextStatus);
        }
    };

    const handleStatusFilterChange = (value) => {
        setStatusFilter(value);
        setCurrentPage(0);
        setSendCurrentPage(0);
        setRecievedCurrentPage(0);
        setMonitoringCurrentPage(0);
        handleSearchFunc(value);
    };

    const checkUpdateFeedbacks = () => {
        if (checkUpdate) clearTimeout(checkUpdate);

        if (messageModal === false) {
            const API =
                userType === "organ"
                    ? GET_FEEDBACK_COUNTS
                    : USER_GET_FEEDBACK_COUNTS;

            get(API)
                .then((r) => {
                    setNewFeedbacksCount(r);
                })
                .catch(() => {});

            checkUpdate = setTimeout(() => {
                checkUpdateFeedbacks();
            }, 5000);
        }
    };

    function s2ab(s) {
        let buf = new ArrayBuffer(s.length);
        let view = new Uint8Array(buf);
        for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    }

    const getExcelFile = () => {
        if (
            itemTypeTreeSelected?.id === "" ||
            itemTypeTreeSelected?.id === undefined
        ) {
            show(t("Src.Pages.Messages.Index.Get.Excel.File.Danger"), "danger");
        } else {
            axios
                .get(FEEDBACK_EXCEL.replace("{id}", itemTypeTreeSelected?.id), {
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${window.sessionStorage.auth}`,
                    },
                })
                .then((response) => {
                    let blob = new Blob([response.data]);
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "export.xlsx");
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((e) => {
                    console.log(e);
                    show(
                        t(
                            "Src.Pages.Messages.Index.Get.Excel.File.Not.Exist.Danger"
                        ),
                        "danger"
                    );
                });
        }
    };

    useEffect(() => {
        if (feedbacks.length !== 0) {
            checkUpdateFeedbacks();
        }
        return () => {
            clearTimeout(checkUpdate);
        };
    }, [messageModal, feedbacks]);

    useEffect(() => {
        getFeedbackCounts();
    }, []);

    useEffect(() => {
        if (feedbackCounts?.monitoring) {
            if (feedbackCounts?.monitoring !== newFeedbacksCount?.monitoring) {
                getFeedbackCounts();
                getMonitoringFeedbackList(
                    { pageIndex: monitoringCurrentPage },
                    false
                );
                setRefreshNewCount((prevState) => !prevState);
            }
        }

        if (feedbackCounts?.feedback_count) {
            if (
                feedbackCounts?.feedback_count !==
                newFeedbacksCount?.feedback_count
            ) {
                getFeedbackCounts();
                getMonitoringFeedbackList(
                    { pageIndex: monitoringCurrentPage },
                    false
                );
                setRefreshNewCount((prevState) => !prevState);
            }
        }

        if (feedbackCounts?.received) {
            if (feedbackCounts?.received !== newFeedbacksCount?.received) {
                getFeedbackCounts();
                getReceivedFeedbackList(
                    { pageIndex: recievedCurrentPage },
                    false
                );
                setRefreshNewCount((prevState) => !prevState);
            }
        }

        if (feedbackCounts?.sent) {
            if (feedbackCounts?.sent !== newFeedbacksCount?.sent) {
                getFeedbackCounts();
                getSendFeddbackList({ pageIndex: sendCurrentPage }, false);
                setRefreshNewCount((prevState) => !prevState);
            }
        }

        if (feedbackCounts?.monitoring && feedbackCounts?.received) {
            if (
                feedbackCounts?.monitoring + feedbackCounts?.received !==
                newFeedbacksCount?.monitoring + newFeedbacksCount?.received
            ) {
                getFeedbackCounts();
                fetchData({ pageIndex: currentPage }, false);
                setRefreshNewCount((prevState) => !prevState);
            }
        }
    }, [newFeedbacksCount]);

    useEffect(
        (_) => {
            if (userType === "organ")
                get(REPORT_GET_ITEM_TYPE_TREE, {
                    company: sessionStorage.getItem("usercompany"),
                }).then((r) => {
                    setItemTypeTree({
                        name: "",
                        id: 0,
                        toggled: true,
                        className: "zeroLevel",
                        children: r,
                    });
                });
        },
        [currentCompany]
    );

    useEffect(() => {
        setSearchStr("");
    }, [searchType]);

    useEffect(() => {
        if (refreshMode === true && messageModal === false) {
            if (activeShowFeedbacks === "send") {
                getSendFeddbackList({ pageIndex: sendCurrentPage }, false);
            } else if (activeShowFeedbacks === "monitoring") {
                getMonitoringFeedbackList(
                    { pageIndex: monitoringCurrentPage },
                    false
                );
            } else if (activeShowFeedbacks === "received") {
                getReceivedFeedbackList(
                    { pageIndex: recievedCurrentPage },
                    false
                );
            } else {
                fetchData({ pageIndex: currentPage }, false);
            }
        }
    }, [refreshMode, messageModal]);

    useEffect(() => {
        fetchData({ pageIndex: currentPage }, true);
    }, [currentCompanyForAdminUser]);
    return (
        <MessageContext.Provider
            value={{
                messageModal,
                setMessageModal,
                feedbackId,
                setFeedbackId,
            }}
        >
            <div id="messages_panel" className="main_panel_box messages_panel ">
                <MainPanelHeader
                    panelType={
                        userType === "user"
                            ? t("User.Portal.label")
                            : t("Corpration.Panel.label")
                    }
                    panelName={t("Messages.label")}
                />
                <div className="main_panel_content">
                    <div className="messages_panel_content main_box">
                        <div className="message-header">
                            <div className="message-toolbar-section">
                                <div
                                    className={
                                        "feedbacks-item-st " +
                                        (activeShowFeedbacks === "all"
                                            ? "active"
                                            : "")
                                    }
                                    onClick={() =>
                                        fetchData(
                                            { pageIndex: currentPage },
                                            true
                                        )
                                    }
                                >
                                    <span>
                                        {t(
                                            "Organizational.Messages.AllMessages.Filter"
                                        )}
                                    </span>
                                </div>
                                {window.sessionStorage.usertype !== "1" &&
                                    userType !== "user" && (
                                        <>
                                            <div
                                                className={
                                                    "feedbacks-item-st " +
                                                    (activeShowFeedbacks ===
                                                    "received"
                                                        ? "active"
                                                        : "")
                                                }
                                                onClick={() =>
                                                    getReceivedFeedbackList(
                                                        {
                                                            pageIndex:
                                                                recievedCurrentPage,
                                                        },
                                                        true
                                                    )
                                                }
                                            >
                                                <span>
                                                    {t(
                                                        "Organizational.Messages.Received.Filter"
                                                    )}
                                                </span>
                                                <span>
                                                    {"( " +
                                                        (feedbackCounts?.received
                                                            ? feedbackCounts?.received
                                                            : 0) +
                                                        " ) "}
                                                </span>
                                            </div>
                                            <div
                                                className={
                                                    "feedbacks-item-st " +
                                                    (activeShowFeedbacks ===
                                                    "send"
                                                        ? "active"
                                                        : "")
                                                }
                                                onClick={() =>
                                                    getSendFeddbackList(
                                                        {
                                                            pageIndex:
                                                                sendCurrentPage,
                                                        },
                                                        true
                                                    )
                                                }
                                            >
                                                <span>
                                                    {t(
                                                        "Organizational.Messages.Sent.Filter"
                                                    )}
                                                </span>
                                                <span>
                                                    {"( " +
                                                        (feedbackCounts?.sent
                                                            ? feedbackCounts?.sent
                                                            : 0) +
                                                        " ) "}
                                                </span>
                                            </div>
                                            <div
                                                className={
                                                    "feedbacks-item-st " +
                                                    (activeShowFeedbacks ===
                                                    "monitoring"
                                                        ? "active"
                                                        : "")
                                                }
                                                onClick={() =>
                                                    getMonitoringFeedbackList(
                                                        {
                                                            pageIndex:
                                                                monitoringCurrentPage,
                                                        },
                                                        true
                                                    )
                                                }
                                            >
                                                <span>
                                                    {t(
                                                        "Organizational.Messages.Supervision.Filter"
                                                    )}
                                                </span>
                                                <span>
                                                    {"( " +
                                                        (feedbackCounts?.monitoring
                                                            ? feedbackCounts?.monitoring
                                                            : 0) +
                                                        " ) "}
                                                </span>
                                            </div>
                                        </>
                                    )}
                                <div className="feedbacks-item-st">
                                    {searchResultsCount !== 0 &&
                                        searchStr !== "" && (
                                            <>
                                                <span>
                                                    {t(
                                                        "Organizational.Messages.All.Result"
                                                    )}
                                                </span>
                                                <span>
                                                    {"( " +
                                                        searchResultsCount +
                                                        " ) "}
                                                </span>
                                            </>
                                        )}
                                </div>
                                <div className="company-selector">
                                    {window.sessionStorage.usertype === "1" && (
                                        <TreeSearchSelect
                                            value={currentCompanyForAdminUser}
                                            onChange={(e) =>
                                                setCurrentCompanyForAdminUser(e)
                                            }
                                            data={compantList}
                                            placeholder={t(
                                                "Organizational.Messages.All.Organizations"
                                            )}
                                        />
                                    )}
                                </div>
                                <div className="view-changer">
                                    <button
                                        className={
                                            "grid-list" +
                                            (viewType === "grid"
                                                ? " selected"
                                                : "")
                                        }
                                        onClick={() => {
                                            setGridView(true);
                                            setViewType("grid");
                                        }}
                                    >
                                        <GridViewIcon />
                                    </button>

                                    <button
                                        className={
                                            "grid-list" +
                                            (viewType === "list"
                                                ? " selected"
                                                : "")
                                        }
                                        onClick={() => {
                                            setGridView(false);
                                            setViewType("list");
                                        }}
                                    >
                                        <ListViewIcon />
                                    </button>
                                </div>
                            </div>
                        </div>
                        {userType !== "user" && (
                            <MessagesAiSummary
                                companyId={currentCompanyForAdminUser}
                            />
                        )}
                        <div
                            className={
                                "toolbar" +
                                (mobileTool === "search"
                                    ? " is-search-open"
                                    : "") +
                                (mobileTool === "filter"
                                    ? " is-filter-open"
                                    : "")
                            }
                        >
                            <div className="toolbar-mobile-actions">
                                <button
                                    type="button"
                                    className={
                                        mobileTool === "search" ? "is-active" : ""
                                    }
                                    aria-expanded={mobileTool === "search"}
                                    onClick={() =>
                                        setMobileTool((current) =>
                                            current === "search" ? null : "search"
                                        )
                                    }
                                >
                                    {t("Organizational.Messgaes.Search.Bar")}
                                </button>
                                <button
                                    type="button"
                                    className={
                                        mobileTool === "filter" ? "is-active" : ""
                                    }
                                    aria-expanded={mobileTool === "filter"}
                                    onClick={() =>
                                        setMobileTool((current) =>
                                            current === "filter" ? null : "filter"
                                        )
                                    }
                                >
                                    {t("Organizational.Messages.Filter.Button")}
                                </button>
                            </div>
                            <div className="toolbar-type">
                                <div className="toolbar-search-panel">
                                <div className="toolbar-search-cluster">
                                    <button
                                        type="button"
                                        className="toolbar-ic pad-st-ic"
                                        aria-label={t(
                                            "UserPanel.dashboard.FeedbackHistoyShowcase.Search.Label",
                                            { defaultValue: "جستجو" }
                                        )}
                                        onClick={() => handleSearchFunc()}
                                    >
                                        <SearchIcon />
                                    </button>

                                    <div
                                        className="toolbar-search"
                                        style={
                                            searchType === "item_type" ||
                                            searchType === "has_file"
                                                ? { display: "none" }
                                                : {}
                                        }
                                    >
                                        <input
                                            type="text"
                                            placeholder="جستجو"
                                            aria-label="جستجو"
                                            onChange={(e) =>
                                                setSearchStr(e.target.value)
                                            }
                                        />
                                    </div>

                                    {searchType === "has_file" && (
                                        <div className="select-box">
                                            <select
                                                className=" field_shadow"
                                                onChange={(e) =>
                                                    setSearchStr(e.target.value)
                                                }
                                            >
                                                <option readOnly>
                                                    {t(
                                                        "UserPanel.ChooseOption.Drop.Bar"
                                                    )}
                                                </option>
                                                <option value="true">
                                                    {t(
                                                        "Organizational.ChooseOption.Has.Image.Drop.Bar"
                                                    )}
                                                </option>
                                                <option value="false">
                                                    {t(
                                                        "Organizational.ChooseOption.No.Image.Drop.Bar"
                                                    )}
                                                </option>
                                            </select>
                                        </div>
                                    )}

                                    {searchType === "item_type" && (
                                        <div className="search-select">
                                            <SearchSelectBox
                                                options={itemTypeTree}
                                                defaultValue={""}
                                                keyForSelect={"parent"}
                                                onSelectFunction={
                                                    itemTypeSelectHandle
                                                }
                                                specialClass={"form_filed"}
                                                readOnly={false}
                                            />
                                        </div>
                                    )}
                                </div>
                                <div className="select-box toolbar-search-type">
                                    <select
                                        className=" field_shadow"
                                        onChange={(e) =>
                                            setSearchType(e.target.value)
                                        }
                                    >
                                        <option readOnly>
                                            {t(
                                                "UserPanel.ChooseOption.Drop.Bar"
                                            )}
                                        </option>
                                        <option value="item_name">
                                            {t(
                                                "UserPanel.Messages.ByItemName.Drop.Filter"
                                            )}
                                        </option>
                                        {userType === "organ" && (
                                            <option value="item_type">
                                                {t(
                                                    "UserPanel.Messages.ByItemType.Drop.Filter"
                                                )}
                                            </option>
                                        )}
                                        <option value="phone_number">
                                            {t(
                                                "UserPanel.Messages.ByPhoneNumber.Drop.Filter"
                                            )}
                                        </option>
                                        <option value="name">
                                            {t(
                                                "UserPanel.Messages.ByUsername.Drop.Filter"
                                            )}
                                        </option>
                                        <option value="has_file">
                                            {t(
                                                "UserPanel.Messages.ByMessagesContainingPictures.Drop.Filter"
                                            )}
                                        </option>
                                        <option value="description">
                                            {t(
                                                "UserPanel.Messages.ByMessagesText.Drop.Filter"
                                            )}
                                        </option>
                                    </select>
                                </div>
                                </div>
                                <div className="toolbar-filter-panel">
                                <MessageStatusFilter
                                    value={statusFilter}
                                    onChange={handleStatusFilterChange}
                                />
                                </div>
                            </div>
                            <div className="toolbar-date toolbar-filter-panel">
                                <div className="select-box visit-count-con">
                                    <div className="toolbar-ic">
                                        <CalenderIcon />
                                    </div>
                                    <select
                                        className="field_shadow"
                                        onChange={(e) =>
                                            setSearchType(e.target.value)
                                        }
                                    >
                                        <option readOnly>
                                            {t(
                                                "UserPanel.Messages.ViewedAmount.Drop.Bar"
                                            )}
                                        </option>
                                        <option value="">
                                            {t(
                                                "UserPanel.Messages.ViewedAmount.All.Drop.Bar"
                                            )}
                                        </option>
                                    </select>
                                </div>
                                <div className="message-date-picker">
                                    <div className="toolbar-ic">
                                        <CalenderIcon />
                                    </div>
                                    <div id="message-date-box">
                                        <span>
                                            {t(
                                                "UserPanel.Surveys&announcments.SurveyAnnouncments.FromDate.Label"
                                            )}
                                        </span>
                                        <input
                                            type=""
                                            value={startDate.fa}
                                            onClick={(e) =>
                                                setStartDatePicker(true)
                                            }
                                            placeholder={t(
                                                "UserPanel.dashboard.FeedbackHistoyShowcase.Date.Label"
                                            )}
                                            className="date-in"
                                        />
                                        <span>
                                            {t(
                                                "UserPanel.Surveys&announcments.SurveyAnnouncments.UntillDate.Label"
                                            )}
                                        </span>
                                        <input
                                            type=""
                                            value={endDate.fa}
                                            onClick={(e) =>
                                                setEndDatePicker(true)
                                            }
                                            placeholder={t(
                                                "UserPanel.dashboard.FeedbackHistoyShowcase.Date.Label"
                                            )}
                                            className="date-in"
                                        />

                                        <DatePickerModal
                                            show={startDatePicker}
                                            close={setStartDatePicker}
                                            defaultValue={startDate.fa}
                                            onChange={setStartDate}
                                        />
                                        <DatePickerModal
                                            show={endDatePicker}
                                            close={setEndDatePicker}
                                            defaultValue={endDate.fa}
                                            onChange={setEndDate}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {loading ? (
                            <div
                                id="messages-loading"
                                className="dideban-loading"
                            >
                                <DidebanLogo />
                            </div>
                        ) : (
                            <>
                                <div className="messages_content_list page-load-fade">
                                    {gridView ? (
                                        <div className="row user_message_row">
                                            {empty ? (
                                                <div className="empty-state">
                                                    {t(
                                                        "Organizational.Messages.NoMessages.Label"
                                                    )}
                                                </div>
                                            ) : loader ? (
                                                <FeedbackItem
                                                    key={1}
                                                    {...{}}
                                                    onItemClick={showModal}
                                                />
                                            ) : (
                                                feedbacks.map(
                                                    (feedback, index) => {
                                                        return (
                                                            <FeedbackItem
                                                                key={index}
                                                                {...feedback}
                                                                onItemClick={
                                                                    showModal
                                                                }
                                                            />
                                                        );
                                                    }
                                                )
                                            )}
                                        </div>
                                    ) : (
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>
                                                        {t(
                                                            "Organizational.Messages.RowNumber.Label"
                                                        )}
                                                    </th>
                                                    <th>
                                                        {t(
                                                            userType === "user"
                                                                ? "UserPanel.Orders.Table.Company"
                                                                : "Organizational.Messages.User.Label"
                                                        )}
                                                    </th>
                                                    <th>
                                                        {t(
                                                            "Organizational.Messages.ItemType.Label"
                                                        )}
                                                    </th>
                                                    <th>
                                                        {t(
                                                            "Organizational.CustomerClub.SearchByItemNName.Drop.Filter"
                                                        )}
                                                    </th>
                                                    <th>
                                                        {t(
                                                            "Organizational.Messages.SentPictures.Label"
                                                        )}
                                                    </th>
                                                    <th>
                                                        {t(
                                                            "Organizational.Messages.Date.Label"
                                                        )}
                                                    </th>
                                                    <th>
                                                        {t(
                                                            "Organizational.Messages.SummaryLabel"
                                                        )}
                                                    </th>
                                                    <th>
                                                        {t(
                                                            "Organizational.Messages.MessagesStatus"
                                                        )}
                                                    </th>
                                                    <th>
                                                        {t(
                                                            "Organizational.Messages.Score.Label"
                                                        )}
                                                    </th>
                                                    {userType === "user" && (
                                                        <th>
                                                            {t(
                                                                "UserPanel.Messages.CoinsEarned"
                                                            )}
                                                        </th>
                                                    )}
                                                    <th>
                                                        {t(
                                                            "Organizational.Messages.Functions.Label"
                                                        )}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {empty ? (
                                                    <tr>
                                                        <td
                                                            className="empty-state"
                                                            style={{
                                                                textAlign:
                                                                    "center",
                                                                background:
                                                                    "#fff",
                                                                padding: "38px",
                                                            }}
                                                            colSpan="10"
                                                        >
                                                            {t(
                                                                "UserPanel.Messages.NoMessages.Label"
                                                            )}
                                                        </td>
                                                    </tr>
                                                ) : loader ? (
                                                    <FeedbackItemList
                                                        key={1}
                                                        {...{}}
                                                        onItemClick={showModal}
                                                    />
                                                ) : (
                                                    feedbacks.map(
                                                        (feedback, index) => {
                                                            return (
                                                                <FeedbackItemList
                                                                    key={index}
                                                                    row={
                                                                        index +
                                                                        1
                                                                    }
                                                                    {...feedback}
                                                                    showCoins={
                                                                        userType ===
                                                                        "user"
                                                                    }
                                                                    onItemClick={
                                                                        showModal
                                                                    }
                                                                />
                                                            );
                                                        }
                                                    )
                                                )}
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                                <div className="messages_content_bottom">
                                    {activeShowFeedbacks === "send" && (
                                        <PaginationComponent
                                            feedbacks={feedbacks}
                                            key={sendCurrentPage}
                                            pageCount={pages}
                                            currentPage={sendCurrentPage}
                                            setCurrentPage={(e) =>
                                                handleCurrentPage(e)
                                            }
                                            fetchData={getSendFeddbackList}
                                        />
                                    )}
                                    {activeShowFeedbacks === "received" && (
                                        <PaginationComponent
                                            feedbacks={feedbacks}
                                            key={recievedCurrentPage}
                                            pageCount={pages}
                                            currentPage={recievedCurrentPage}
                                            setCurrentPage={(e) =>
                                                handleCurrentPage(e)
                                            }
                                            fetchData={getReceivedFeedbackList}
                                        />
                                    )}
                                    {activeShowFeedbacks === "monitoring" && (
                                        <PaginationComponent
                                            feedbacks={feedbacks}
                                            key={monitoringCurrentPage}
                                            pageCount={pages}
                                            currentPage={monitoringCurrentPage}
                                            setCurrentPage={(e) =>
                                                handleCurrentPage(e)
                                            }
                                            fetchData={
                                                getMonitoringFeedbackList
                                            }
                                        />
                                    )}
                                    {activeShowFeedbacks === "all" && (
                                        <PaginationComponent
                                            feedbacks={feedbacks}
                                            key={currentPage}
                                            pageCount={pages}
                                            currentPage={currentPage}
                                            setCurrentPage={(e) =>
                                                handleCurrentPage(e)
                                            }
                                            fetchData={fetchData}
                                        />
                                    )}
                                    {userType === "organ" && (
                                        <Button
                                            download
                                            className="export_btn d-none d-lg-flex"
                                            onClick={getExcelFile}
                                        >
                                            <img
                                                src={excelIcon}
                                                className="icon"
                                                alt=""
                                            />
                                            <span className="text">
                                                {t(
                                                    "Organizational.Messages.ExcelExport.Button"
                                                )}
                                            </span>
                                        </Button>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                </div>
                <MessagesModal
                    userType={userType}
                    onBookmark={handleBookmarkChange}
                    setRefreshMode={setRefreshMode}
                    refreshMode={refreshMode}
                />
            </div>
        </MessageContext.Provider>
    );
}
